import axios from "axios"

const ACCESS_TOKEN = "xq81ilbjkvj3h53bl65dzpm2uatirp"

const TWITCH_API = axios.create({
    headers: {
        "Authorization": `Bearer ${ACCESS_TOKEN}`,
        "Client-ID": "y72hvvoahxa93xufswek3x2cgovjuy",
    }
})

export default TWITCH_API